(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/result/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/lotto/components/result/assets/javascripts/prescript.js'); 
'use strict';

svs.lotto = svs.lotto || {};
svs.lotto.components = svs.lotto.components || {};
svs.lotto.components.result = svs.lotto.components.result || {};
svs.lotto.components.result.views = svs.lotto.components.result.views || {};
 })(window);